// Bonusun geçerli olduğu oyun türleri. Alan tek bir metindir ama birden çok
// tür taşıyabilir ('slots,casino'); 'all' tek başına durur. Etiketler hem
// yönetim panelinde hem promosyon sayfasında bu dosyadan okunur — iki yerde
// ayrı yazılırsa kampanya kartı ile panel farklı şey söyler.
export const BONUS_ELIGIBLE_TYPES = [
  { id: 'slots', name: 'Slot' },
  { id: 'casino', name: 'Canlı Casino' },
  { id: 'sports', name: 'Spor' },
];

export const ALL_GAMES_LABEL = 'Tüm oyunlar';

/** 'slots,casino' → ['slots', 'casino'] (tanınmayan değer elenir). */
export const parseBonusEligible = (value) => {
  const picked = new Set(
    String(value || '').split(',').map((part) => part.trim().toLowerCase()),
  );
  if (picked.has('all')) return [];
  return BONUS_ELIGIBLE_TYPES
    .filter((type) => picked.has(type.id))
    .map((type) => type.id);
};

/** ['slots', 'casino'] → 'slots,casino'; boş seçim 'all' demektir. */
export const serializeBonusEligible = (ids) => {
  const picked = new Set(ids || []);
  const chosen = BONUS_ELIGIBLE_TYPES
    .filter((type) => picked.has(type.id))
    .map((type) => type.id);
  return chosen.length ? chosen.join(',') : 'all';
};

/** Kullanıcıya gösterilecek metin: 'Slot, Canlı Casino' ya da 'Tüm oyunlar'. */
export const formatBonusEligible = (value) => {
  const ids = parseBonusEligible(value);
  if (!ids.length) return ALL_GAMES_LABEL;
  return BONUS_ELIGIBLE_TYPES
    .filter((type) => ids.includes(type.id))
    .map((type) => type.name)
    .join(', ');
};
